<template>
    <vue-cookie-accept-decline :debug="false" :disableDecline="true" :showPostponeButton="false"
        @clicked-accept="cookieClickedAccept" @clicked-decline="cookieClickedDecline"
        @clicked-postpone="cookieClickedPostpone" @removed-cookie="cookieRemovedCookie" @status="cookieStatus"
        elementId="myPanel1" position="bottom" ref="cookie-popup-ref" transitionName="slideFromBottom" type="bar">
        <!-- Optional -->
        <template #postponeContent>&times;</template>

        <!-- Optional -->
        <template #message>
            ASCA values your privacy and uses cookies only for necessary and critical transactions. By clicking
            'Accept', you consent to the use of our cookies.
            <a href="https://asca.org/privacy-policy/" target="_blank">ASCA Privacy Policy</a>
        </template>

        <!-- Optional -->
        <template #declineContent>Decline</template>

        <!-- Optional -->
        <template #acceptContent>Accept</template>
    </vue-cookie-accept-decline>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
    name: "CookiePrompt", methods: {
        cookieClickedAccept(e: any) {
        },
        cookieClickedDecline(e: any) {
        },
        cookieClickedPostpone(e: any) {
        },
        cookieRemovedCookie(e: any) {
        },
        cookieStatus(e: any) {
        },
    }
});
</script>